"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsignmentDetailSchema = exports.ConsigneeSchema = exports.FormAnswerSchema = exports.DeclarationSchema = exports.LocationEntitySchema = exports.AddressSchema = exports.FormTypeSchema = void 0;
const zod_1 = require("zod");
const TokenMisc = __importStar(require("./token"));
const AssetMisc = __importStar(require("./asset"));
const business_1 = require("./business");
exports.FormTypeSchema = zod_1.z.enum(["LPAC1", "HSC2"]);
exports.AddressSchema = zod_1.z.object({
    line1: zod_1.z.string(),
    postcode: zod_1.z.string(),
    state: zod_1.z.string(),
    town: zod_1.z.string()
});
exports.LocationEntitySchema = zod_1.z.object({
    name: zod_1.z.string(),
    pic: zod_1.z.string(),
    address: exports.AddressSchema
});
exports.DeclarationSchema = zod_1.z.object({
    fullName: zod_1.z.string(),
    address: exports.AddressSchema,
    date: zod_1.z.string(),
    phone: zod_1.z.string(),
    email: zod_1.z.string(),
    signature: zod_1.z.string(),
});
exports.FormAnswerSchema = zod_1.z.object({
    questionId: zod_1.z.string(),
    index: zod_1.z.number().nullable(),
    value: zod_1.z.string(),
});
//Consignee
exports.ConsigneeSchema = zod_1.z.object({
    id: zod_1.z.string(),
    pic: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    postCode: zod_1.z.string().optional(),
    town: zod_1.z.string().optional(),
    state: zod_1.z.string().optional(),
    address: zod_1.z.string().optional(),
});
// Consignment
exports.ConsignmentDetailSchema = zod_1.z.object({
    name: zod_1.z.string(),
    consignee: exports.ConsigneeSchema.optional(),
    assets: zod_1.z.array(zod_1.z.object({
        type: zod_1.z.literal(TokenMisc.tokenTypesSchema.enum.asset),
        details: AssetMisc.AssetDetailSchema,
        rfid: zod_1.z.string().optional(),
        agliveToken: zod_1.z.string().optional(),
        nlis: zod_1.z.string().optional(),
        birthYear: zod_1.z.string().optional(),
        mob: zod_1.z.string().optional()
    })),
    destination: zod_1.z.object({
        pic: zod_1.z.string(),
        postCode: zod_1.z.string().optional(),
        town: zod_1.z.string().optional(),
        state: zod_1.z.string().optional(),
        address: zod_1.z.string().optional(),
    }).optional(),
    origin: business_1.AustraliaLocationSchema.optional(),
    declaration: exports.DeclarationSchema.merge(zod_1.z.object({
        userId: zod_1.z.string()
    })).optional(),
    animalSelectionMode: zod_1.z.enum([
        "Individual Animal Selection",
        "Group/Mob Selection",
        "CSV file Selection",
        "plant",
        "product"
    ]),
    csvFile: zod_1.z.object({
        name: zod_1.z.string(),
        link: zod_1.z.string()
    }).optional(),
    mob: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        type: zod_1.z.string()
    }).optional(),
    template: zod_1.z.array(zod_1.z.object({
        docId: zod_1.z.string(),
        name: zod_1.z.string(),
        type: exports.FormTypeSchema
    })).optional(),
    forms: zod_1.z.array(exports.FormTypeSchema),
    answers: zod_1.z.array(exports.FormAnswerSchema),
    shareTo: zod_1.z.object({
        mobile: zod_1.z.array(zod_1.z.string()),
        email: zod_1.z.array(zod_1.z.string()),
    }).optional(),
    attachments: zod_1.z.string().array(),
    consignmentNumber: zod_1.z.string().optional(),
    formNo: zod_1.z.array(zod_1.z.object({
        type: zod_1.z.string(),
        agliveNo: zod_1.z.string(),
        serialNumber: zod_1.z.string()
    })),
    eNVDS3Link: zod_1.z.string().optional(),
    submit: zod_1.z.object({
        at: zod_1.z.date(),
        query: zod_1.z.string()
    }),
    externalIds: TokenMisc.ExternalIdsSchema,
    sender: zod_1.z.object({
        name: zod_1.z.string(),
        companyName: zod_1.z.string(),
        email: zod_1.z.string().optional()
    }),
    receiver: zod_1.z.object({
        name: zod_1.z.string(),
        companyName: zod_1.z.string(),
        email: zod_1.z.string().optional()
    }),
});
